import { render, staticRenderFns } from "./comp_CheckoutDeliveryOptionItem.vue?vue&type=template&id=368b5d20&scoped=true"
import script from "./comp_CheckoutDeliveryOptionItem.vue?vue&type=script&lang=js"
export * from "./comp_CheckoutDeliveryOptionItem.vue?vue&type=script&lang=js"
import style0 from "./comp_CheckoutDeliveryOptionItem.vue?vue&type=style&index=0&id=368b5d20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368b5d20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio})
